import { useMemo } from 'react'
import { getUser, useUser } from '../stores';
import { isChatGroup } from '../utils';
import { ChatChannelInstance } from "../types";

export function useChatDMUser(channel: ChatChannelInstance) {
    const isGroup = isChatGroup(channel)
    const user = useUser()
    const userId = user?.id

   const dmUser = useMemo(() => {
    if (isGroup) return null

    return Object.values(channel?.state?.members || {}).find((user) => user.user_id !== userId)
   }, [channel?.state?.members, isGroup, userId])

    return { dmUser }
}